module.exports = __webpack_public_path__ + "static/media/bg.29fc8373.svg";